import { render, staticRenderFns } from "./uploadList.vue?vue&type=template&id=52cb6c92&scoped=true&"
import script from "./uploadList.vue?vue&type=script&lang=js&"
export * from "./uploadList.vue?vue&type=script&lang=js&"
import style0 from "./uploadList.vue?vue&type=style&index=0&id=52cb6c92&lang=scss&scoped=true&"
import style1 from "./icons/icon.scss?vue&type=style&index=1&id=52cb6c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cb6c92",
  null
  
)

export default component.exports